import React, { useEffect, useState } from 'react';

import {
    Paper,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Tabs,
    Tab,
    AppBar,
    Avatar,
    Input,
    Chip,
    Checkbox,
    ListItemText,
    makeStyles,
    FormControlLabel,
    Grid,
    Card,
    CardHeader,
    CardContent,
    Menu,
    IconButton,
    Tooltip,
} from '@material-ui/core';
import AlarmIcon from '@material-ui/icons/Alarm';
import {
    getEventosGruposPequenos,
    getFrequenciaEventos,
    getGrupos,
    getMembrosByGrupo,
    getSessoesEventosGruposPequenos,
    salvarFrequenciaMembro
} from '../../services/GruposApi';

const useStyles = makeStyles((theme) => ({
    header: {
        padding: theme.spacing(2)
    },
    grid: {
        marginTop: theme.spacing(1),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
    table: {
        minWidth: '100%',
    },
    tab: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
}));

function Frequencia() {
    const classes = useStyles();

    const [eventos, setEventos] = useState([]);
    const [grupos, setGrupos] = useState([]);
    const [membros, setMembros] = useState([]);
    const [tabIndex, setTabIndex] = useState(0);
    const [sessoes, setSessoes] = useState([]);
    const [frequencia, setFrequencia] = useState([]);
    const [eventosSelecionados, setEventosSelecionados] = useState([]);
    const [processando, setProcessando] = useState(new Map());
    const [menuItems, setItemsMenu] = useState([]);
    const [menuEl, setMenuEl] = useState(null);
    const [carregandoEventos, setCarregandoEventos] = useState(false);
    const [carregandoSessoes, setCarregandoSessoes] = useState(false);

    const handleEventosChange = (event) => {
        if (carregandoEventos || carregandoSessoes) {
            return;
        }

        setEventosSelecionados(event.target.value);
    };

    const handleTabChange = (_event, index) => {
        setTabIndex(index);
    }

    const handleMenuClose = () => {
        setMenuEl(null);
    }

    const registrarFrequencia = async (idxRegistro, idxEvento, idSessao) => {
        const idMembro = membros[idxRegistro].idMembro;
        const idEvento = eventosSelecionados[idxEvento].id;

        const registro = frequencia.find((f) => f.idMembro === idMembro && f.idEvento === idEvento);
        const processandoKey = `${tabIndex};${idMembro};${idEvento}`;

        setProcessando(new Map(Object.entries({ ...processando, [processandoKey]: true })));

        if (registro) {
            setFrequencia(frequencia.map((el) => {
                if (el === registro) {
                    return { ...el, idSessao: idSessao };
                } else {
                    return el;
                }
            }));
        } else {
            setFrequencia([...frequencia, { idMembro: idMembro, idEvento: idEvento, idSessao: idSessao }]);
        }

        try {
            await salvarFrequenciaMembro(idMembro, idEvento, idSessao);
        } catch (err) {
            console.log(err);

            setFrequencia([...frequencia, { idMembro: idMembro, idEvento: idEvento, idSessao: registro ? registro.idSessao : null }]);
        }

        setProcessando(new Map(Object.entries({ ...processando, [processandoKey]: false })));
    }

    const handleFrequenciaClick = async (event, idxRegistro, idxEvento, horarioNormal) => {
        const idMembro = membros[idxRegistro].idMembro;
        const idEvento = eventosSelecionados[idxEvento].id;

        const registro = frequencia.find((f) => f.idMembro === idMembro && f.idEvento === idEvento);

        const idSessaoAtual = registro ? registro.idSessao : null;
        let idSessaoNova = null;

        if (idSessaoAtual == null) {
            const tipoEvento = eventosSelecionados[idxEvento].tipo;

            if (sessoes[idxEvento].length === 1) {
                idSessaoNova = sessoes[idxEvento][0].id;
            } else if (tipoEvento === 2 && sessoes[idxEvento].length > 1) {
                const nbCulto = membros[idxRegistro].nbCulto;

                if (nbCulto) {
                    const idIgreja = membros[idxRegistro].idIgreja;
                    const sessao = sessoes[idxEvento].find((s) => s.idIgreja === idIgreja && s.nbCulto === nbCulto);

                    if (sessao) {
                        idSessaoNova = sessao.id;
                    }
                }
            }
        }

        if (horarioNormal === false || (idSessaoAtual === null && idSessaoNova === null)) {
            const novosItemsMenu = [];

            for (let i = 0; i < sessoes[idxEvento].length; i++) {
                const sessao = sessoes[idxEvento][i];
                const menuItemText = sessao.dhSessao ? (`PARTICIPOU EM ${sessao.dhSessao}` + (sessao.igreja ? ` NA ${sessao.igreja}` : "")) : ("PARTICIPOU" + (sessao.igreja ? ` NA ${sessao.igreja}` : ""));

                novosItemsMenu.push({ text: menuItemText, idxRegistro: idxRegistro, idxEvento: idxEvento, idSessao: sessao.id });
            }

            setItemsMenu(novosItemsMenu);
            setMenuEl(event.currentTarget);
        } else {
            registrarFrequencia(idxRegistro, idxEvento, idSessaoNova)
        }
    }

    const handleMenuClick = async (idxRegistro, idxEvento, idSessao) => {
        handleMenuClose();
        registrarFrequencia(idxRegistro, idxEvento, idSessao);
    }

    const fetchEventos = async () => {
        try {
            const novosEventos = await (await getEventosGruposPequenos()).data;
            const eventosAtivos = novosEventos.filter((el) => el.ativo === 1).reverse();

            setEventos(eventosAtivos);
        } catch (err) {
            console.log(err);
        }
    }

    const fetchGrupos = async () => {
        try {
            const novosGrupos = await (await getGrupos()).data;
            setGrupos(novosGrupos);

            if (novosGrupos.length > 0) {
                fetchMembros(novosGrupos[0].idGrupoPequeno);
            }
        } catch (err) {
            console.log(err);
        }
    }

    const fetchMembros = async (idGrupoPequeno) => {
        try {
            const novosMembros = await (await getMembrosByGrupo(idGrupoPequeno)).data;
            setMembros(novosMembros);
        } catch (err) {
            console.log(err);
        }
    }

    const fetchSessoes = async () => {
        setCarregandoSessoes(true);

        try {
            const ids = eventosSelecionados.map((e) => e.id);
            const novasSessoes = (await getSessoesEventosGruposPequenos(ids)).map((s) => s.data);

            setSessoes(novasSessoes);
        } catch (err) {
            console.log(err);
        }

        setCarregandoSessoes(false);
    }

    const fetchFrequencia = async (idGrupoPequeno) => {
        setCarregandoEventos(true);

        try {
            const ids = eventosSelecionados.map((e) => e.id).join(',');
            const novaFrequencia = await (await getFrequenciaEventos(idGrupoPequeno, ids)).data;

            setFrequencia(novaFrequencia);
        } catch (err) {
            console.log(err);
        }

        setCarregandoEventos(false);
    }

    useEffect(() => {
        fetchEventos();
        fetchGrupos();
    }, []);

    useEffect(() => {
        if (grupos.length > 0) {
            fetchMembros(grupos[tabIndex].idGrupoPequeno);
        }
    }, [grupos, tabIndex]);

    useEffect(() => {
        if (grupos.length > 0 && eventosSelecionados.length > 0) {
            fetchFrequencia(grupos[tabIndex].idGrupoPequeno);
        }
    }, [grupos, tabIndex, eventosSelecionados]);

    useEffect(() => {
        if (grupos.length > 0 && eventosSelecionados.length > 0) {
            fetchSessoes();
        }
    }, [grupos, eventosSelecionados]);

    return (
        <div className={classes.root}>
            <Paper>
                <div className={classes.header}>
                    <FormControl className={classes.formControl}>
                        <InputLabel>Eventos</InputLabel>
                        <Select
                            multiple
                            value={eventosSelecionados}
                            onChange={handleEventosChange}
                            input={<Input />}
                            renderValue={(selected) => (
                                <div className={classes.chips}>
                                    {selected.map((evento) => (
                                        <Chip key={evento.id} label={evento.descricao} className={classes.chip} />
                                    ))}
                                </div>
                            )}
                        >
                            {eventos.map((evento) => (
                                <MenuItem key={evento.id} value={evento}>
                                    <Checkbox color="primary" checked={eventosSelecionados.indexOf(evento) > -1} disabled={carregandoEventos || carregandoSessoes} />
                                    <ListItemText primary={evento.descricao} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>

                <AppBar position="static" style={{ zIndex: 1000 }}>
                    <Tabs value={tabIndex} onChange={handleTabChange}>
                        {grupos.map((grupo, i) => (
                            <Tab
                                key={grupo.idGrupoPequeno}
                                value={i}
                                label={
                                    grupos.length > 1 ? `GA DE ${grupo.txDiaSemanaReuniao}` : 'MEU GA'
                                }
                            />
                        ))}
                    </Tabs>
                </AppBar>
            </Paper>

            {eventosSelecionados.length > 0 && <Grid container spacing={2} className={classes.grid}>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        {membros.map((registro, idxRegistro) => (
                            <Grid
                                item
                                key={registro.idMembro}
                                xs={12}
                                sm={6}
                                md={4}
                                lg={4}
                            >
                                <Card>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                className={classes.avatar}
                                                src={registro.txFotoUrl}
                                                alt={registro.txMembro}
                                            />
                                        }
                                        title={registro.txMembro}
                                        subheader={`(${registro.nbCulto ? registro.nbCulto + '° CULTO' : 'SEM CULTO'})`}
                                    />
                                    <CardContent>
                                        {eventosSelecionados.map(
                                            (evento, idxEvento) => (
                                                <FormControl fullWidth>
                                                    <FormControlLabel
                                                        key={
                                                            `${tabIndex};${registro.idMembro};${evento.id}`
                                                        }
                                                        label={
                                                            <div>
                                                                {evento.descricao}{" "}
                                                                {
                                                                    evento.tipo === 2 && Boolean(registro.nbCulto) &&
                                                                    <Tooltip title="Presença em horário diferente">
                                                                        <IconButton size="small" color="primary" onClick={(event) => {
                                                                            handleFrequenciaClick(
                                                                                event,
                                                                                idxRegistro,
                                                                                idxEvento,
                                                                                false,
                                                                            );
                                                                        }}>
                                                                            <AlarmIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                }
                                                            </div>
                                                        }
                                                        className={
                                                            classes.item
                                                        }
                                                        control={
                                                            <Checkbox
                                                                color="primary"
                                                                checked={
                                                                    frequencia.findIndex((f) => f.idMembro === registro.idMembro && f.idEvento === evento.id && f.idSessao !== null) > -1
                                                                }
                                                                disabled={processando.get(`${tabIndex};${registro.idMembro};${evento.id}`) || carregandoEventos || carregandoSessoes}
                                                                onChange={(event) => {
                                                                    handleFrequenciaClick(
                                                                        event,
                                                                        idxRegistro,
                                                                        idxEvento,
                                                                        true,
                                                                    );
                                                                }}
                                                            />
                                                        }
                                                    />

                                                </FormControl>
                                            )
                                        )}
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>}

            <Menu
                keepMounted
                anchorEl={menuEl}
                open={Boolean(menuEl)}
                onClose={handleMenuClose}
            >
                {menuItems.map((item) => <MenuItem onClick={() => handleMenuClick(item.idxRegistro, item.idxEvento, item.idSessao)}>{item.text}</MenuItem>)}
            </Menu>
        </div>
    );
}

export default Frequencia;
